import * as React from 'react';
import { Spinner } from '@cian/ui-kit';

import * as styles from './ServicesLoaderMask.css';

interface IProps {
  isLoading: boolean;
  children: React.ReactNode;
}

export const ServicesLoaderMask = ({ isLoading, children }: IProps) => (
  <div className={styles['loader-mask-wrapper']}>
    {isLoading && (
      <div className={styles['loader-mask-spinner']}>
        <Spinner size={80} />
      </div>
    )}

    {children}
  </div>
);
